<template>
  <div style="background: #000000;">
    <div>
      <van-nav-bar :title="$t('video.video')" class="header_b">
      </van-nav-bar>
    </div>
    <div class="video_box">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        :pulling-text="$t('refresh.pulling')"
        :loosing-text="$t('refresh.loosing')"
        :loading-text="$t('refresh.loading')"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :loading-text="$t('refresh.loading')"
          :finished-text="$t('video.no_more')"
          @load="onLoad"
        >
          <div class="list-item">
            <div
              class="movie-list-item"
              v-for="i in data"
              :key="i.id"
              @click="toPlayVideo(i.id)"
            >
              <div class="imb_box">
                <img :src="i.vod_pic" class="van_img" />
                <div class="cc_zan">{{ $t("video.play") }} :{{ i.count }}</div>
              </div>
              <div class="c_yy">{{ i.vod_name }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div style="height: 55px;"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      data: [],
    };
  },
  methods: {
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.data = [];
      }
      this.loading = true;
      this.getAllVideos()
        .then(() => {
          this.loading = false;
          this.finished = true;
          if (this.refreshing) {
            this.refreshing = false;
            Toast(this.$t("refresh.loosing"));
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },
    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    extractList(res) {
      if (!res || res.code === 401) return [];
      const d = res.data;
      if (Array.isArray(d)) return d;
      if (d && Array.isArray(d.data)) return d.data;
      return [];
    },
    // 按分类把每一页都拉完（兼容线上旧接口每页 8 条），再去重
    async fetchClassAllPages(classId) {
      const out = [];
      for (let page = 1; page <= 100; page++) {
        let res;
        try {
          res = await this.$http({
            method: "get",
            data: { id: classId, page },
            url: "video_list",
          });
        } catch (e) {
          break;
        }
        const list = this.extractList(res);
        if (!list.length) break;
        out.push.apply(out, list);
        if (list.length < 8) break;
      }
      return out;
    },
    async getAllVideos() {
      let classes = [];
      try {
        const classRes = await this.$http({
          method: "get",
          url: "video_class",
        });
        classes = Array.isArray(classRes && classRes.data)
          ? classRes.data
          : [];
      } catch (e) {
        classes = [];
      }
      const ids = [888].concat(
        classes.map((c) => c.id).filter((id) => id != null && id !== 888)
      );
      const chunks = await Promise.all(
        ids.map((id) => this.fetchClassAllPages(id))
      );
      const map = new Map();
      chunks.forEach((arr) => {
        (arr || []).forEach((v) => {
          if (v && v.id != null && !map.has(v.id)) map.set(v.id, v);
        });
      });
      // 每次打开/刷新随机打乱顺序
      this.data = this.shuffleArray(Array.from(map.values()));
    },
    shuffleArray(arr) {
      const list = arr.slice();
      for (let i = list.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const t = list[i];
        list[i] = list[j];
        list[j] = t;
      }
      return list;
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: #000 !important;
  border-bottom: 1px solid rgba(201, 168, 76, 0.45);
}
::v-deep .van-nav-bar__title {
  color: #c9a84c !important;
}
.header_b{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
.video_box{
  padding-top: 100px;
  background: #000000;
  min-height: 100vh;
  .c_yy{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #c9a84c;
    font-size: 30px;
    padding: 12px 0 30px;
  }
  .movie-list-item{
    background: #141414;
    border-radius: 16px;
    border: 1px solid rgba(201, 168, 76, 0.35);
    padding: 16px;
    margin-bottom: 16px;
    .imb_box{
      position: relative;
      .van_img{
        height: 300px;
        width: 100%;
        border-radius: 20px;
      }
      .cc_zan{
        position: absolute;
        background: rgba(201, 168, 76, 0.9);
        border-radius: 20px 0;
        color: #000;
        bottom: 26px;
        right: 26px;
        font-size: 24px;
        padding: 2px 16px;
      }
    }
  }
}
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}

/deep/ .van-tabs__line {
  background-color: #c9a84c;
}

/deep/ .van-loading__text {
  font-size: 32px;
  color: #c9a84c;
}

/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #c8c8c8;
}

/deep/ .van-pull-refresh__head {
  height: 100px;
}

/deep/ .van-pull-refresh__text {
  font-size: 32px;
  color: #c9a84c;
}

.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.movie-list-item {
  width: calc(50% - 12px);
}

.cover_img {
  border-radius: 20px;
}

.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}

.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #c9a84c;
  border-radius: 0 0 40px 40px;
}

.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}

.activeBg {
  color: #c9a84c;
  font-weight: bold;
  background: url('/img/new.png') right top 5px / 30% no-repeat;
}
</style>
